// extracted by mini-css-extract-plugin
export default {"text":"WidgetPreview--text--b23798","preview":"WidgetPreview--preview--fbaaff","tooltipWrapper":"WidgetPreview--tooltipWrapper--13bd63"};